import React    from 'react';

export type CoverItem = {
    ariaLabel: string;
    dataElementDescription: string;
    href: string;
    header?: JSX.Element;
    title: JSX.Element;
    text?: JSX.Element;
    buttonText: string;
    smallText?: JSX.Element;
    sign?: JSX.Element;
};

const customGameCoverSettings = [
    // test example
    //  {
    //      title: <div>Overwite </div>,
    //      text: <div>test 111<br/> <a  style = {{color: '#2b779b'}} href = "google.com"><b>LINK 111</b></a></div>,
    //      buttonText: 'TEST Button Text',
    //      slug: 'ten-x-ten',
    //  },
];

export const GetCoverByGame = (slug: string, settings: CoverItem): CoverItem  => {
    const found = customGameCoverSettings.find(item => item.slug === slug);
    if (found) {
        settings.title = found.title;
        settings.text = found.text;
        settings.buttonText = found.buttonText;
    }
    return settings;
}